import { Link, NavLink } from "react-router-dom"
import { useSelector } from "react-redux"
import "./GuestLayout.css"

const GuestLayout = (props) => {
  const userState = useSelector(state => state.user)
  const { cart } = useSelector(state => state.cart)

  const jumpTo = (id) => {
    const section = document.getElementById(id)
    if (section) section.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <>
      {
        props.header && <nav className="bg-theme-secondary d-none d-md-block">
          <div className="container">
            <ul className="nav gap-5 justify-content-center">
              <li className="nav-item"><Link to="#" className="nav-link link-secondary"><i className="bi bi-telephone me-2"></i> 0326-2023423</Link></li>
              <li className="nav-item"><Link to="#" className="nav-link link-secondary"><i className="bi bi-envelope me-2"></i> info@phonicspk.com</Link></li>
              <li className="nav-item"><Link to="#" className="nav-link link-secondary"><i className="bi bi-globe2 me-2"></i> phonicspk.com</Link></li>
            </ul>
          </div>
        </nav>
      }
      {
        props.header && <nav className="navbar navbar-expand-lg navbar-light bg-secondary py-1 py-lg-0">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src="/logo192.png" width={48} />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav ms-auto align-items-center">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/#hero" onClick={() => jumpTo("hero")}>Home</NavLink>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/#deals" onClick={() => jumpTo("deals")}>Deals</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/#products" onClick={() => jumpTo("products")}>Products</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/#about" onClick={() => jumpTo("about")}>About</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/#contact" onClick={() => jumpTo("contact")}>Contact</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/#apps" onClick={() => jumpTo("apps")}>Apps</Link>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/complaint">Complaint</NavLink>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/cart">
                    <span className="d-flex gap-2 align-items-center">
                      <i className="bi bi-basket"></i>
                      <p className="fs-6 fw-bold m-0">{cart.length}</p>
                    </span>
                  </Link>
                </li>
                {!userState.user && <li className="nav-item">
                  <NavLink className="btn btn-sm btn-theme rounded-2" to="/login">Login</NavLink>
                </li>}
                {userState.user && <li className="nav-item">
                  <NavLink className="btn btn-sm btn-theme rounded-2" to="/dashboard">Dashboard</NavLink>
                </li>}
              </ul>
            </div>
          </div>
        </nav>
      }
      {props.children}
      {/* {
        false && <footer>
          <div className="container">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5">
              <div className="col mb-3">
                <Link to="/" className="d-flex align-items-center mb-3 link-body-emphasis text-decoration-none">
                  <img src="/logo192.png" width={60} />
                </Link>
                <p className="text-body-secondary">Phonics &copy; {new Date().getFullYear()}, Powered by <Link to="https://interacksolutions.com?source=phonicspk.com" className="text-decoration-none" target="_blank">Interack Solutions LLC</Link></p>
              </div>
              <div className="col mb-3"></div>
              <div className="col mb-3">
                <ul className="nav flex-column">
                  <li className="nav-item mb-2"><Link to="/" className="nav-link p-0 text-body-secondary">Home</Link></li>
                  <li className="nav-item mb-2"><Link to="/about" className="nav-link p-0 text-body-secondary">About</Link></li>
                  <li className="nav-item mb-2"><Link to="/contact" className="nav-link p-0 text-body-secondary">Contact</Link></li>
                  <li className="nav-item mb-2"><Link to="/complaint" className="nav-link p-0 text-body-secondary">Complaint</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Login</Link></li>
                </ul>
              </div>
              <div className="col mb-3">
                <ul className="nav flex-column">
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Terms of Use</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Privacy Policy</Link></li>
                </ul>
              </div>
              <div className="col mb-3">
                <ul className="nav flex-column">
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Home</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Features</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">Pricing</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">FAQs</Link></li>
                  <li className="nav-item mb-2"><Link to="#" className="nav-link p-0 text-body-secondary">About</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      } */}
      {props.footer && <footer className="text-center py-2">
        <div className="container">
          <p className="lead m-0">Phonics &copy; {new Date().getFullYear()}, Powered by <Link to="https://interacksolutions.com?source=phonicspk.com" className="text-decoration-none" target="_blank">Interack Solutions LLC</Link></p>
        </div>
      </footer>}
    </>
  )
}

export default GuestLayout
